<template>
    <p class="body text-ink-muted">{{ t("settings.deleteAccount.consequences.intro") }}</p>
    <ul class="list-disc pl-5 body text-ink-muted space-y-1">
        <li v-for="consequence in deletionConsequences" :key="consequence">{{ consequence }}</li>
    </ul>
    <p class="body-bold text-button-danger">{{ t("settings.deleteAccount.consequences.irreversible") }}</p>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const deletionConsequences = computed(() => [
    t("settings.deleteAccount.consequences.deactivate"),
    t("settings.deleteAccount.consequences.preventLogin"),
    t("settings.deleteAccount.consequences.dataDeletion"),
]);
</script>
